import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { ErrorsService } from './core/services/errors/errors.service';
import { GlobalLoaderService } from '@core/services/global-loader.service';
import { AuthService } from '@auth0/auth0-angular';
import { filter, firstValueFrom, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AttributionService } from '@core/services/marketing/attribution.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public title = 'cs-platform';
  public constructor(
    public errorService: ErrorsService,
    public globalLoaderService: GlobalLoaderService,
    private auth: AuthService,
    private router: Router,
    private attribution: AttributionService,
  ){}
  
  async ngOnInit() {
    // Scroll to top on every route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0 });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });

    // A guard returning false / a rejected guard-or-resolver promise aborts a
    // navigation with NO user-visible feedback (a click that "does nothing").
    // Outside production, surface every aborted navigation with its reason so
    // those reports are diagnosable from the console (BF-48).
    if (!environment.production) {
      this.router.events
        .pipe(filter((e) => e instanceof NavigationCancel || e instanceof NavigationError))
        .subscribe((e) => {
          if (e instanceof NavigationCancel) {
            console.warn(`[router] navigation to "${e.url}" cancelled (code ${e.code}): ${e.reason}`);
          } else if (e instanceof NavigationError) {
            console.warn(`[router] navigation to "${e.url}" errored:`, e.error);
          }
        });
    }

    // CS-3375: attribution is persisted tenant-side by the post-login Action, so
    // a missing claim is the only signal the browser gets that the Action never
    // received the ext-* params. Surface it outside production. Subscribed (not
    // awaited) because the appState$ await below never resolves on normal loads.
    if (!environment.production) {
      this.auth.user$
        .pipe(filter((user) => !!user), take(1))
        .subscribe((user) => this.attribution.warnIfNotPersisted(user));
    }

    // Handle the redirect and retrieve custom data from appState$
    const auth0State = await firstValueFrom(this.auth.appState$)
    // Redirect to the intended page with query parameters
    if (auth0State.redirect) {
      window.location.href = auth0State.redirect;
    }
  }
}
